<template>
    <div class="hello">
    <!-- @submit.prevent=""表示提交事件不再重载页面 -->
        <transition-group name="fade" mode="out-in">
            <form v-if="visable" @submit.prevent="ready" key='ready'>
                <div class="wrap">
                    <input v-model="name" id='' type="text" autocomplete="off">
                    <button type="submit">输入名字<br>开始测试</button>
                </div>
            </form>
            
            <div v-if="!visable" class="wrap" key="dati" >
                <form title='jiejueduiqi' v-if='ischecked' key='timu'>{{list[this.last_id].timu}}</form> 
                <transition-group name="list-complete" >
                    <span v-for='(ans,index) in list[this.last_id].neirong' :key="ans" class="list-complete-item">
                        <li @click="click_ans(index)" >
                        {{ans}}
                        </li>  
                    </span>
                </transition-group>
            
                <transition-group name="fade" mode="out-in">
                    <div v-if='last_id  == (this.list.length -1 )' @click="ans_show" key='datiover'>
                        <button class='' v-if='ischecked'>查看答案</button>
                    </div>
                    <form class='wrap' v-if='!ischecked' @submit.prevent="reset_ans" key='daan'>
                    
                        <div class='daan' v-if='ans_id' key='chongxie'>
                            <li>{{name}}</li>
                            
                            <li>{{ans_wow[this.ans_id]}}</li>
                            
                            
                        </div>
                        <button type="submit">重新测试</button>  
                    </form>
                </transition-group>

            </div>   
        </transition-group> 
    </div>
</template>

<script >
export default {
  data () {
    return{
        name: '',
        list:[
            {timu:'Someday，是指哪一天？',
            neirong:['1 某一天','2 永远不会去做的一种托词',]},
            {timu:'“God，This is Amarican”，出自一下那部影视作品？',
            neirong:['1 《The Wire》','2 《西部世界》','3 《阿甘正传》',]},
            {timu:'微微一抖是什么意思？',
            neirong:['1 微信微博抖音','2 男性上厕所后需要做的动作',]},
            {timu:'回答完毕',
            neirong:[]}, 

        ],
        last_id: 0,
        visable : true,
        ischecked : true,
        user_ans:[],
        ans_wow:[
            '「闭门造车，出门合辙」',
            `「我曾七次鄙视自己的灵魂： 
            第一次，当它本可进取时，却故作谦卑； 
            第二次，当它在空虚时，用爱欲来填充； 
            第三次，在困难和容易之间，它选择了容易；
            第四次，它犯了错，却借由别人也会犯错来宽慰自己； 
            第五次，它自由软弱，却把它认为是生命的坚韧； 
            第六次，当它鄙夷一张丑恶的嘴脸时，却不知那正是自己面具中的一副； 
            第七次，它侧身于生活的污泥中，虽不甘心，却又畏首畏尾」`,
            `「本来生活给你一些东西，
            让你沉淀体会成长，
            你却要在它还没沉淀下的时候，
            把你觉得自己独特的看法，
            比别人多的东西迫不及待地拿出来炫耀，
            实打实也就罢了，
            偏偏三分要夸成七分，
            七分要讲成圆满。
            不管对面人的心情，
            自顾自开心地讲下去......」`,  
            `「记忆既不是短暂易散的云雾，
            也不是干爽的透明，
            而是烧焦的生灵在城市表面结成的痂，
            是浸透了不再流动的生命液体的海绵，
            是过去、现在与未来混合而成的果酱，
            把运动中的存在给钙化封存起来：这才是你在旅行终点的发现」`,
            `「每次抵达一个新城市，
            旅人都会再度发现一段自己不知道的过去：你不复存在的故我或者你已经失去主权的东西，这变异的感觉埋伏在无主的异地守候你」`,
            '「幸有我来山未孤」',
            '「菩萨，祝你身体健康」',
            '「没有实力，就没有童话」',
            '「项脊枇杷，今如盖矣」',
            '「没带就是没写」',
            '「无穷的远方，无数的人们，都和我有关」',
            '「大丈夫当带三尺之剑，立不世之功，所志未遂，奈何死乎」',
            '「You are be watched」',
            '「人之患在好为人师」',
            '「对未来的真正慷慨 是把一切都献给现在」',


        ],
        ans_id:null,
       
    }
  },
     
  mounted () {  
    
  
    console.log(this.last_id)    
  },
  methods:{

      click_ans: function(id){
          var me = this
          if ( this.last_id < this.list.length ) {
          // 用index的方法取出用户所选择的条目
          var ans = this.list[this.last_id].neirong[id];
          // 题目序号自增，用来更新题目
          this.last_id += 1;
          // 把用户所选择的都存起来
          this.user_ans.push(ans)
        
          console.log('this.user_ans:',this.user_ans,this.user_ans.length);
          }
      },

      ready : function(){
          this.visable = false
          console.log(this.last_id)
          console.log('name:',this.name)
      },

      ans_show: function(){
          
          var ans_number = this.user_ans[0][0] + this.user_ans[1][0]+ this.user_ans[2][0];
          switch(ans_number){
              default:
              this.ans_id = '0';
              console.log(ans_number);
              break;
              case '111':this.ans_id = '1';break;
              case '112':this.ans_id = '2';break;
              case '132':this.ans_id = '3';break;
              case '131':this.ans_id = '4';break;
              case '122':this.ans_id = '5';break;
              case '121':this.ans_id = '6';break;
              case '222':this.ans_id = '7';break;
              case '221':this.ans_id = '8';break;
              case '232':this.ans_id = '9';break;
              case '231':this.ans_id = '10';break;
              case '212':this.ans_id = '11';break;
              case '211':this.ans_id = '12';break;
              

          };
          console.log('ans_showed')
          this.ischecked = false ;
      },
      reset_ans: function(){
          this.user_ans = [];
          this.last_id =  0;
          this.ischecked =  !this.ischecked,
          console.log(this.user_ans,
          this.last_id,)

          
      },
        
  },

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
    
}

button  {
  /*  字体  */
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
  background:#42b983;
  border-radius: 5px;
  outline: none;
  /*  字号 */
  font-size: 12px;
  font-weight: 400;
  color: #fafcfb;
  /* 行距 */
  line-height: 1.75;
  margin-top: 8px
}

[title] {
  padding: 0 5%;
}


input {
  border-style: solid; 
  border-top-width: 0px;
  border-right-width: 0px; 
  border-bottom-width: 1px;
  border-left-width: 0px;
  outline:none ;
  border-bottom-color: #42b983;
  text-align: center;
}

.wrap {
  padding:3% ;
    display: flex;
    display: -webkit-flex; /* Safari */
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
}

.wrap a {
  display: flex;
  align-self:flex-start;
}



 
.fade-enter-active {
  transition: all .3s ease;
}
/* .fade-leave-active {
  transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
} */



.list-item {
    display: inline-block; 
  }


.list-complete-item {
    transition: all 1s;
    display: block;
    margin-top: 1px;
  }
.list-complete-enter, .list-complete-leave-to,.fade-enter, .fade-leave-to 
  /* .list-complete-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform:  translateX(20px);
  }

.list-complete-leave-active {
    position: absolute;
  }


h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin-top: 20px;
  color: #42b983;
}
a {
  color: #42b983;
  margin: 10px;

}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue